import { client } from "src/services/client";
import { SchoolView } from "src/types/school.type";

export interface SchoolSeachQuery {
    searchText?: string;
    limit?: number;
}
export const searchSchool = (query?: SchoolSeachQuery) =>
    client.post<{ schools: SchoolView[] }>("/school/search", query).then((res) => res.data);
